// src/pages/processifyd/ProcessifydVariables.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faFolderOpen,
  faSearch,
  faTimes,
  faChevronLeft,
  faChevronRight,
  faList,
} from "@fortawesome/free-solid-svg-icons";

const ProcessifydVariables = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [variables, setVariables] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 8;

  const [showModal, setShowModal] = useState(false);
  const [editingVariable, setEditingVariable] = useState(null);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const [loading, setLoading] = useState(false);
  
  const initialForm = {
    variableGroup: "",
    variableName: "",
    aboutTheVariable: "",
    active: "Yes",
  };

  const [formData, setFormData] = useState(initialForm);

  // Sample Demo Data
  const demoVariables = [
    {
      id: 1,
      variableGroup: "Courier",
      variableName: "Blue Dart",
      aboutTheVariable: "Blue Dart Courier",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "12/12/23 15:32",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "12/12/23 15:32",
    },
    {
      id: 2,
      variableGroup: "Courier",
      variableName: "DHL",
      aboutTheVariable: "DHL International Courier Service",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:00",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:00",
    },
    {
      id: 3,
      variableGroup: "Courier",
      variableName: "First Flight",
      aboutTheVariable: "First Flight Domestic Courier Service",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:01",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:01",
    },
    {
      id: 4,
      variableGroup: "Courier",
      variableName: "DTDC",
      aboutTheVariable: "DTDC Express Courier Service",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:02",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:02",
    },
    {
      id: 5,
      variableGroup: "Courier",
      variableName: "Overnite Express",
      aboutTheVariable: "Overnite Express Logistics Service",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:03",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:03",
    },
    {
      id: 6,
      variableGroup: "Payment Gateway",
      variableName: "Razorpay",
      aboutTheVariable: "Razorpay Payment Processing Service",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "10/01/24 11:45",
      lastUpdatedBy: "Priya Sharma",
      lastUpdateDate: "05/03/24 09:30",
    },
    {
      id: 7,
      variableGroup: "Payment Gateway",
      variableName: "PayU",
      aboutTheVariable: "PayU Payment Gateway Service",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:05",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:05",
    },
    {
      id: 8,
      variableGroup: "Loan Product",
      variableName: "Personal Loan",
      aboutTheVariable: "Unsecured loan for personal use",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:06",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:06",
    },
    {
      id: 9,
      variableGroup: "Loan Product",
      variableName: "Business Loan",
      aboutTheVariable: "Loan provided for MSME or business purposes",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:07",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:07",
    },
    {
      id: 10,
      variableGroup: "Customer Segment",
      variableName: "Retail Customer",
      aboutTheVariable: "Individual retail banking customer",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:08",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:08",
    },
    {
      id: 11,
      variableGroup: "Customer Segment",
      variableName: "MSME Customer",
      aboutTheVariable: "Micro, Small and Medium Enterprise customer",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:09",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:09",
    },
    {
      id: 12,
      variableGroup: "Document Type",
      variableName: "PAN Card",
      aboutTheVariable: "Permanent Account Number for identity verification",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:10",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:10",
    },
    {
      id: 13,
      variableGroup: "Document Type",
      variableName: "Aadhaar Card",
      aboutTheVariable: "Government issued identity document",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:11",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:11",
    },
  ];

  const loadSample = () => {
    setVariables(demoVariables);
  };

  const handleAddNew = () => {
    setEditingVariable(null);
    setFormData(initialForm);
    setShowModal(true);
  };

  const handleEdit = (variable) => {
    setEditingVariable(variable);
    setFormData({
      variableGroup: variable.variableGroup || "",
      variableName: variable.variableName || "",
      aboutTheVariable: variable.aboutTheVariable || "",
      active: variable.active || "Yes",
    });
    setShowModal(true);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this variable? This action cannot be undone.")) return;
    setVariables((prev) => prev.filter((v) => v.id !== id));
  };

  const handleOpenVariable = (variable) => {
    // Update this route as per your actual variable detail page
    navigate(`/processifyd-variablehub/${variable.id}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.variableGroup.trim() || !formData.variableName.trim()) {
      alert("Variable Group and Variable Name are required.");
      return;
    }

    const newVariable = {
      id: editingVariable?.id || Date.now(),
      ...formData,
      createdBy: editingVariable?.createdBy || "Sanjeev Kumar",
      createdDate: editingVariable?.createdDate || new Date().toLocaleString("en-IN"),
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: new Date().toLocaleString("en-IN"),
    };

    if (editingVariable) {
      setVariables((prev) =>
        prev.map((v) => (v.id === editingVariable.id ? newVariable : v))
      );
    } else {
      setVariables((prev) => [...prev, newVariable]);
    }

    setShowModal(false);
    setFormData(initialForm);
  };

  // Filter + Pagination
  const filtered = variables.filter(
    (v) =>
      v.variableName.toLowerCase().includes(search.toLowerCase()) ||
      v.variableGroup.toLowerCase().includes(search.toLowerCase()) ||
      v.aboutTheVariable.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / perPage);
  const paginated = filtered.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const [showList, setShowList] = useState(false);
    
  const handleShowMyVariables = async () => {
    try {
      setLoading(true);

      // 🔄 Replace this later with API call
      // const response = await axios.get("/api/variables");
      // setVariables(response.data);

      // ✅ Temporary Demo Data (remove later)
      setVariables([]);

      setShowList(true);
    } catch (error) {
      console.error("Error fetching variables:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 p-4 md:p-6">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-black border-b border-blue-500/40 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-cyan-300">
            📊 Processifyd
          </div>
          <div className="text-xs text-gray-400">
            Variables Master Management
          </div>
        </div>

        <div className="hidden md:flex items-center gap-4">
          {isLoggedIn ? (
            <>
              <span className="text-xs text-teal-300">{userName}</span>
              <button
                onClick={handleLogout}
                className="w-12 px-2 py-1 bg-red-700/80 hover:bg-red-600 rounded-md text-sm"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="w-12 px-2 py-1 border border-teal-600 hover:bg-teal-900/30 rounded-md"
            >
              🔐
            </button>
          )}
        </div>

        <button
          className="md:hidden text-2xl text-cyan-300"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-4">
          {isLoggedIn && (
            <div className="flex flex-col items-center gap-4">
              <div className="text-teal-300">{userName}</div>
              <button onClick={handleLogout} className="w-12 px-2 py-1 bg-red-700 rounded-md">⏻</button>
            </div>
          )}
        </div>
      )}

      <div className="min-h-[75vh]">
        {/* Controls */}
        <div className="mt-4 flex flex-col lg:flex-row gap-4">
          <div className="flex flex-row gap-3">
            <button
              onClick={loadSample}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-48 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faPlus} />
              Load Sample Variables
            </button>
            <button
              onClick={handleShowMyVariables}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 lg:w-48 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faList} />
              My Variables List
            </button>
            <button
              onClick={handleAddNew}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-48 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faPlus} />
              New Variable
            </button>
          </div>

          <div className="relative w-full">
            <FontAwesomeIcon
              icon={faSearch}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
            />
            <input
              type="text"
              placeholder="Search by variable name, group or description..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:border-cyan-500/60"
            />
          </div>
        </div>

        {/* Variables Cards */}
        <div className="mt-4 grid gap-4 grid-cols-1 lg:grid-cols-3 xl:grid-cols-4">
          {paginated.map((variable) => (
            <div
              key={variable.id}
              className="bg-gray-800 border border-gray-700 rounded-xl p-5 hover:border-cyan-600/50 transition-colors group"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <h3 className="font-semibold text-base text-white group-hover:text-cyan-300 transition-colors">
                    {variable.variableName}
                  </h3>
                  <div className="text-sm text-gray-400 mt-1">
                    Group: <span className="text-cyan-300">{variable.variableGroup}</span>
                  </div>
                </div>

                <span className={`px-3 py-1 rounded-full text-xs font-medium ${variable.active === "Yes" ? "bg-emerald-600" : "bg-red-600"}`}>
                  {variable.active === "Yes" ? "Active" : "Inactive"}
                </span>
              </div>

              <p className="mt-4 text-sm text-gray-300 line-clamp-3">
                {variable.aboutTheVariable || "No description available"}
              </p>

              <div className="mt-6 flex gap-2">
                <button
                  onClick={() => handleOpenVariable(variable)}
                  className="flex-1 py-2 bg-gradient-to-r from-cyan-700 to-teal-700 hover:from-cyan-600 hover:to-teal-600 rounded-lg font-medium flex items-center justify-center gap-2 text-sm"
                >
                  <FontAwesomeIcon icon={faFolderOpen} />
                  Open
                </button>

                <button
                  onClick={() => handleEdit(variable)}
                  className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  title="Edit Variable"
                >
                  <FontAwesomeIcon icon={faEdit} className="text-yellow-400" />
                </button>

                <button
                  onClick={() => handleDelete(variable.id)}
                  className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  title="Delete Variable"
                >
                  <FontAwesomeIcon icon={faTrash} className="text-red-400" />
                </button>
              </div>
            </div>
          ))}

          {paginated.length === 0 && (
            <div className="col-span-full py-12 text-center text-gray-500">
              {search ? "No variables match your search" : "No variables yet. Click 'New Variable' or 'Load Sample Variables'"}
            </div>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center gap-4 mt-10">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
              className="w-10 px-2 py-2 bg-gray-800 border border-gray-700 rounded-lg disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <span className="text-sm">
              Page <strong>{currentPage}</strong> of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
              className="w-10 px-2 py-2 bg-gray-800 border border-gray-700 rounded-lg disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        )}

        {showList && (
          <div className="mt-4 bg-black text-white rounded-lg p-4">
            {loading ? (
              <p className="text-yellow-200">Loading variables...</p>
            ) : variables.length === 0 ? (
              <p className="text-yellow-200">No variables found.</p>
            ) : (
              <ul className="space-y-2">
                {variables.map((vari) => (
                  <li
                    key={vari.id}
                    className="border border-gray-700 rounded p-2"
                  >
                    <p className="font-semibold text-gray-100">{vari.variableName}</p>
                    <p className="font-semibold text-gray-100">{vari.variableGroup}</p>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}

        {/* Add / Edit Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-50">
            <div className="bg-gray-800 rounded-xl p-6 w-full max-w-lg border border-gray-700 max-h-[92vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-cyan-300">
                  {editingVariable ? "Edit Variable" : "New Variable"}
                </h2>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-400 hover:text-white w-12 text-2xl"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm mb-1.5">Variable Group <span className="text-red-400">*</span></label>
                  <input
                    required
                    value={formData.variableGroup}
                    onChange={(e) => setFormData({ ...formData, variableGroup: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="e.g. Courier, Payment Gateway, Status, etc."
                  />
                </div>

                <div>
                  <label className="block text-sm mb-1.5">Variable Name <span className="text-red-400">*</span></label>
                  <input
                    required
                    value={formData.variableName}
                    onChange={(e) => setFormData({ ...formData, variableName: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="e.g. Blue Dart"
                  />
                </div>

                <div>
                  <label className="block text-sm mb-1.5">About the Variable</label>
                  <textarea
                    value={formData.aboutTheVariable}
                    onChange={(e) => setFormData({ ...formData, aboutTheVariable: e.target.value })}
                    rows={4}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="Short description about this variable..."
                  />
                </div>

                <div>
                  <label className="block text-sm mb-1.5">Active <span className="text-red-400">*</span></label>
                  <select
                    value={formData.active}
                    onChange={(e) => setFormData({ ...formData, active: e.target.value })}
                    className="w-full h-12 px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg"
                  >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div className="flex justify-end gap-3 mt-8">
                  <button
                    type="button"
                    onClick={() => setShowModal(false)}
                    className="px-6 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-8 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
                  >
                    {editingVariable ? "Update Variable" : "Create Variable"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <footer className="bg-black border-t border-blue-400 text-white py-4 mt-8">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <a href="/about-us" className="hover:text-teal-300">About</a>
            <a href="/privacy-policy" className="hover:text-teal-300">Privacy Policy</a>
            <a href="/terms-of-use" className="hover:text-teal-300">Terms of Use</a>
            <a href="/contact-us" className="hover:text-teal-300">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProcessifydVariables;